import { render, staticRenderFns } from "./detailInformation.vue?vue&type=template&id=23129493"
import script from "./detailInformation.vue?vue&type=script&lang=js"
export * from "./detailInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports